export const DEBUG_PREFIX = '__debug_';

export const DEBUG_DEFAULTS = {
  idle_warning_time: 60,
  idle_logout_time: 30,
  ns_allow_old_evo: true,
  ns_force_battery_percentage: 50,
};

const randomID = () =>
  Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, '')
    .substr(0, 10);

export class SavsuDebugger {
  constructor() {
    // Add 'Hooks' to allow advanced debugging features.
    this.hooks = {}; // { 'trigger_some_change': [[ <unique-id>, <callback> ]] }

    // Check to see if this is a functional dev environment
    this.isDevelopment = process.env.NODE_ENV === 'development';
    this.localStorageSupported =
      window.localStorage && window.localStorage.setItem && window.localStorage.removeItem && true;

    // Initialize defaults in development environments
    if (this.isDevelopment && this.localStorageSupported) {
      Object.entries(DEBUG_DEFAULTS).map(([key, value]) => {
        if (this.get(key) === null) {
          this.set(key, value);
        }
      });
    }
  }

  hook(str, func) {
    const id = randomID();

    this.hooks[str] = this.hooks[str] || [];
    this.hooks[str].push([id, func]);

    return () => {
      this.unhook(str, id);
    };
  }

  unhook(str, id) {
    this.hooks[str] = this.hooks[str].filter((_id, _func) => _id !== id);
  }

  trigger(str, ...args) {
    this.hooks[str].map((e) => e(...args));
  }

  set(key, value) {
    return window.localStorage.setItem(`${DEBUG_PREFIX}${key}`, value);
  }

  get(key, defaultValue) {
    const value = window.localStorage.getItem(`${DEBUG_PREFIX}${key}`);

    if (defaultValue !== undefined && (value === null || value === undefined)) {
      return defaultValue;
    }

    return value;
  }
}

export const initDebugger = () => {
  window.__SAVSU_DEBUG = new SavsuDebugger();
};
